export enum ApElementType {
  P = 1,
  K = 2,
  Mg = 3,
  CaO = 4,
  N = 5
}
